
export const TRANSITION_TIMING = {
  fast: "0.2s",
  normal: "0.3s",
  slow: "0.4s",
  slower: "0.6s",
  slowest: "1s",
} as const;

export const TRANSITION_EASING = {
  linear: "linear",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  
  cubicSmooth: "cubic-bezier(0.4, 0, 0.2, 1)",
  cubicSharp: "cubic-bezier(0.4, 0, 1, 1)",
  cubicSoft: "cubic-bezier(0.25, 0.46, 0.45, 0.94)",
} as const;

export const TRANSITIONS = {
  color: `color ${TRANSITION_TIMING.normal} ${TRANSITION_EASING.cubicSmooth}`,
  colorSlow: `color ${TRANSITION_TIMING.slow} ${TRANSITION_EASING.cubicSmooth}`,
  
  backgroundColor: `background-color ${TRANSITION_TIMING.normal} ${TRANSITION_EASING.cubicSmooth}`,
  
  transform: `transform ${TRANSITION_TIMING.normal} ${TRANSITION_EASING.cubicSmooth}`,
  transformFast: `transform ${TRANSITION_TIMING.fast} ${TRANSITION_EASING.cubicSmooth}`,
  
  height: `height ${TRANSITION_TIMING.normal} ${TRANSITION_EASING.cubicSmooth}`,
  
  opacity: `opacity ${TRANSITION_TIMING.normal} ${TRANSITION_EASING.cubicSmooth}`,
  opacityFast: `opacity ${TRANSITION_TIMING.fast} ${TRANSITION_EASING.cubicSmooth}`,
  
  boxShadow: `box-shadow ${TRANSITION_TIMING.normal} ease`,
  
  border: `border ${TRANSITION_TIMING.normal} ${TRANSITION_EASING.cubicSmooth}`,
  
  all: `all ${TRANSITION_TIMING.normal} ${TRANSITION_EASING.cubicSmooth}`,
  allSlow: `all ${TRANSITION_TIMING.slow} ${TRANSITION_EASING.cubicSmooth}`,
  
  colorAndShadow: `color ${TRANSITION_TIMING.normal} ${TRANSITION_EASING.cubicSmooth}, box-shadow ${TRANSITION_TIMING.normal} ease`,
  colorAndHeight: `color ${TRANSITION_TIMING.normal} ${TRANSITION_EASING.cubicSmooth}, height ${TRANSITION_TIMING.normal} ${TRANSITION_EASING.cubicSmooth}`,
} as const;

export const ANIMATION_TIMING = {
  fast: "0.25s",
  normal: "0.3s",
  slow: "0.5s",
} as const;

export const ANIMATIONS = {
  fadeIn: {
    keyframes: {
      from: { opacity: 0 },
      to: { opacity: 1 },
    },
    duration: ANIMATION_TIMING.normal,
  },
  
  fadeOut: {
    keyframes: {
      from: { opacity: 1 },
      to: { opacity: 0 },
    },
    duration: ANIMATION_TIMING.normal,
  },
  
  slideUp: {
    keyframes: {
      from: { transform: "translateY(10px)", opacity: 0 },
      to: { transform: "translateY(0)", opacity: 1 },
    },
    duration: ANIMATION_TIMING.normal,
  },
  
  slideDown: {
    keyframes: {
      from: { transform: "translateY(-10px)", opacity: 0 },
      to: { transform: "translateY(0)", opacity: 1 },
    },
    duration: ANIMATION_TIMING.normal,
  },
} as const;

export type Transition = typeof TRANSITIONS;














